import React from 'react';

import usePage from '@dashboard/hooks/usePage';

import Divider from '@dashboard/components/Divider';
import Link from '@dashboard/components/Link';

import PageEditView from '../../components/PageEditView';
import FilesForm from '../PageSettings/components/FilesForm';
import ProductDiscountsForm from '../PageSettings/components/ProductDiscountsForm';

import ProductDescriptionForm from './components/ProductDescriptionForm';
import ProductDetailsForm from './components/ProductDetailsForm';
import ProductFilesForm from './components/ProductFilesForm';
import ProductInventoryForm from './components/ProductInventoryForm';
import ProductLicenseKeysForm from './components/ProductLicenseKeysForm';
import ProductMediaForm from './components/ProductMediaForm';
import ProductVariantsForm from './components/ProductVariantsForm';

const PageProduct = () => {
  const { page } = usePage();

  return (
    <PageEditView
      tabs={[
        {
          path: '/details',
          label: 'Details',
          component: <ProductDetailsForm product={page.product} />,
        },
        {
          path: '/description',
          label: 'Description',
          component: <ProductDescriptionForm />,
        },
        {
          path: '/image-gallery',
          label: 'Image gallery',
          component: <ProductMediaForm />,
        },
        {
          path: '/variants',
          label: 'Variants',
          component: <ProductVariantsForm />,
          description: (
            <>
              Sell product variations, subscription tiers, event ticket types and order bumps.{' '}
              <Link to="/help/articles/guide-to-product-variants" color="default" target="_blank">
                Learn more
              </Link>
            </>
          ),
        },
        {
          path: '/file-downloads',
          label: 'File downloads',
          component: (
            <>
              <ProductFilesForm />

              {page.productType === 'subscription' && (
                <>
                  <Divider className="my-8" />
                  <FilesForm />
                </>
              )}
            </>
          ),
          description: (
            <>
              Upload files to sell digital products.{' '}
              <Link to="/help/articles/how-to-sell-digital-downloads" color="default" target="_blank">
                Learn more
              </Link>
            </>
          ),
        },
        {
          path: '/inventory',
          label: 'Inventory',
          component: <ProductInventoryForm />,
        },
        {
          path: '/license-keys',
          label: 'License keys',
          component: <ProductLicenseKeysForm />,
          description: (
            <>
              Verify purchases in your application and grant or revoke access to your customers.{' '}
              <Link to="/help/articles/license-keys" target="_blank">
                Learn more
              </Link>
            </>
          ),
        },
        ...(page.productType === 'charge'
          ? [
              {
                path: '/bulk-discounts',
                label: 'Bulk discounts',
                description: <>Offer discounts based on the number of items purchased.</>,
                component: <ProductDiscountsForm />,
              },
            ]
          : []),
      ]}
    />
  );
};

export default PageProduct;
